<template>
  <div id="menu-component">
    <div
      id="menuicon"
      v-bind:class="{ active: displayMenu }"
      v-on:click="displayMenu = !displayMenu"
    >
      <div id="bar1" class="bar"></div>
      <div id="bar2" class="bar"></div>
      <div id="bar3" class="bar"></div>
    </div>

    <!-- Menu -->
    <nav id="menu" v-if="displayMenu" v-on:click="displayMenu = !displayMenu">
      <button id="fullscreen-mode" v-on:click="fullScreenMode">
        Modo Pantalla Completa
      </button>
      <div class="links-container">
        <ul class="links">
          <li v-on:click="showPlayers">Jugadores</li>
          <li v-on:click="showRules">Reglas</li>
          <!-- <li v-on:click="resetGame">Salir</li> -->
          <li v-on:click="restartGame">Reiniciar</li>
          <li>
            <a href="https://www.instagram.com/seprendio.app/" target="_blank"
              >Siguenos!</a
            >
          </li>
        </ul>
      </div>
      <div class="actions-container">
        <ul class="actions">
          <li id="donate" v-on:click="donate">Donar</li>
          <!-- <li id="suggestion">Hacer una Sugerencia</li> -->
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Menu",
  data() {
    return {
      displayMenu: false
    };
  },
  methods: {
    showPlayers() {
      this.$emit("showPlayers");
    },
    restartGame() {
      this.$emit("restartGame");
    },
    showRules() {
      this.$emit("showRules");
    },
    resetGame() {
      this.$emit("resetGame");
    },
    donate() {
      this.$emit("donate");
    },
    fullScreenMode() {
      if (!document.fullscreenElement) {
        this.openFullscreen();
      } else {
        this.closeFullscreen();
      }
    },
    openFullscreen() {
      let app = document.getElementById("app");
      if (app.requestFullscreen) {
        app.requestFullscreen();
      } else if (app.mozRequestFullScreen) {
        /* Firefox */
        app.mozRequestFullScreen();
      } else if (app.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        app.webkitRequestFullscreen();
      } else if (app.msRequestFullscreen) {
        /* IE/Edge */
        app.msRequestFullscreen();
      }
    },
    closeFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../stylesheets/theme";

#menuicon {
  display: flex;
  flex-flow: column;
  width: 2rem;
  align-self: center;
  padding: 0.8rem 0.55rem;
  border-radius: 100px;
  box-shadow: 0 0 20px #00000050;
  background-color: color(white);
  cursor: pointer;
  position: absolute;
  top: 3%;
  right: 5%;
  z-index: 2;
  @include medium {
    top: 5%;
  }
  &::before {
    background-color: transparent;
    border: 5px solid color(white);
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 100px;
    animation: pulse 900ms ease-out infinite forwards;
    @keyframes pulse {
      0% {
        transform: scale(0);
        opacity: 0;
      }
      50% {
        transform: scale(0.83);
        opacity: 0.5;
      }
      100% {
        transform: scale(1.7);
        opacity: 0;
      }
    }
  }
  .bar {
    height: 4px;
    border-radius: 100px;
    margin: 2px;
    background-color: color(mGray);
    transition: all 350ms;
    z-index: 1;
  }
  &.active {
    .bar {
      transform: rotate(360deg);
    }
    #bar1 {
      transform: rotate(225deg) translateX(-5px) translateY(-5px);
    }
    #bar2 {
      opacity: 0;
    }
    #bar3 {
      transform: rotate(-225deg) translateX(-6px) translateY(6px);
    }
  }
}

#menu {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-flow: column;
  text-align: center;
  justify-content: center;
  overflow: hidden;
  z-index: 1;

  div {
    display: flex;
    justify-content: center;
    ul {
      align-self: center;
      li {
        color: color(white);
        border-radius: 100px;
        padding: 2vh 10vw;
        margin: 3vh 0;
        font-family: font(tFont);
        font-size: 3vh;
        letter-spacing: 2px;
        cursor: pointer;
        animation: fade-in 500ms ease 350ms 1 both;
        box-shadow: 0 0 20px #00000050;
        @keyframes fade-in {
          0% {
            transform: translateY(200%);
            opacity: 0;
          }
          100% {
            transform: translateY(0);
            opacity: 1;
          }
        }

        &:nth-child(1) {
          background-image: linear-gradient(
            to right,
            color(action),
            darken(color(action), 10%)
          );
        }
        &:nth-child(2) {
          background-image: linear-gradient(
            to right,
            color(success),
            darken(color(success), 10%)
          );
        }
        &:nth-child(3) {
          background-image: linear-gradient(
            to right,
            color(danger),
            darken(color(danger), 10%)
          );
        }
        &:nth-child(4) {
          background-image: linear-gradient(to right, #8d2180, #700992);
        }

        a {
          text-decoration: none;
          color: color(white);
        }
      }
      @for $i from 1 through 6 {
        li {
          &:nth-child(#{$i}) {
            // Delay the animation. Delay increases as items loop.
            animation-delay: $i * (200ms);
          }
        }
      }
    }
  }
  #fullscreen-mode {
    animation: fade-in 500ms ease 350ms 1 both;
    box-shadow: 0 0 20px #00000050;
    position: absolute;
    top: 4%;
    left: 3%;
    z-index: 1;
    padding: 0 5vw;
    background-color: #fff;
    @include medium {
      top: 5%;
    }
    &.active {
      color: color(white);
      background-color: color(black);
    }
  }
  .links-container {
    height: 70%;
    //background-color: transparentize(color(action), .5);
    background-color: transparentize(color(dGray), 0.2);
    animation: slide-left 300ms ease 1 both;
    @keyframes slide-left {
      0% {
        transform: translateX(100%);
      }
      100% {
        transform: translateX(0);
      }
    }
  }
  .actions-container {
    height: 30%;
    background-color: transparentize(color(dGray), 0.2);
    animation: slide-up 300ms ease 1 both;
    @keyframes slide-up {
      0% {
        transform: translateY(100%);
      }
      100% {
        transform: translateY(0);
      }
    }
    .actions {
      li {
        margin: 3vh 0;
      }
      #donate {
        background-image: linear-gradient(
          to right,
          color(pColor),
          color(sColor)
        );
      }
      #suggestion {
        background-color: color(mGray);
      }
    }
  }
}
</style>
